module.exports = __webpack_public_path__ + "static/media/pink-tick.6bef4b30.png";